import { Controller } from "@hotwired/stimulus"

// Searchable dialog for switching the membership shown on /profile.
//
// <div data-controller="membership-switcher">
//   <button type="button" data-action="membership-switcher#open">Switch membership</button>
//   <dialog data-membership-switcher-target="dialog">
//     <input data-membership-switcher-target="input" data-action="input->membership-switcher#filter">
//     <li data-membership-switcher-target="item" data-name="working dues">...</li>
//     <li data-membership-switcher-target="empty" class="hidden">No matches</li>
//   </dialog>
// </div>
export default class extends Controller {
  static targets = ["dialog", "input", "item", "empty"]

  open() {
    this.dialogTarget.showModal()
    if (this.hasInputTarget) this.inputTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let visible = 0

    this.itemTargets.forEach((item) => {
      const match = item.dataset.name.includes(query)
      item.classList.toggle("hidden", !match)
      if (match) visible += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visible > 0)
  }
}
